import { EMBEDDED_IDLE_TIME, IDLE_TIME } from '../constants/common.constants';
import { ENDPOINT } from '../constants/routing';

export function getIdleTime() {
  if (window.location.pathname.includes(ENDPOINT.EMBEDDED_JOURNEY.LAYOUT)) {
    return EMBEDDED_IDLE_TIME;
  }

  return IDLE_TIME;
}
